<template>
  <FeedFilterTag :on-click="handleClick">
    {{ parameter?.name || '' }}: {{ value }}
  </FeedFilterTag>
</template>

<script setup>
import _ from 'lodash-es';
import { parameterValueLabel } from '@utils/parameters';
import { useEnumStore } from '@stores/enum';
import FeedFilterTag from "@components/filter/feed/feed-filter-tag";

const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  source: {
    type: String,
    default: 'content' // "content" | "catalogue"
  }
});

const route = useRoute();
const enums = useEnumStore();

const isCatalogue = computed(() => props.source === 'catalogue');

const parameter = computed(() => _.find((isCatalogue.value ? enums.catalogueParameters : enums.contentParameters) || [], { id: props.data.idParameter }));
const value = computed(() => parameterValueLabel(props.data, parameter.value));

const handleClick = async () => {
  const params = { ...route.query };
  const queryKey = `${isCatalogue.value ? 'c' : 't'}[${props.data.idParameter}]`;
  if (props.data.idValue == null) {
    await useSearchParam(queryKey, '');
    return;
  }
  await useSearchParam(queryKey, _.chain(params[queryKey] || '').split(',').filter(idValue => parseInt(idValue) !== props.data.idValue).join(',').value());
}

</script>
